import { generalMessages } from 'src/utils/messages';

import type { BadgeOptions } from 'src/types';

export const badgeYesNoOptions: BadgeOptions = {
    true: {
        theme: 'green',
        label: generalMessages.yes,
    },
    false: {
        theme: 'red',
        label: generalMessages.no,
    },
};
